module.exports = __webpack_public_path__ + "epdf-app/dashboard/ladprovider/ladprovider-details-OWa7xbrW.html";